import { forwardRef } from 'react';
import { Badge, type BadgeProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BALANCE_STATUS_COLOR, balanceStatusKey, type BalanceStatus } from '../lib/balance';

type Props = { status: BalanceStatus } & Omit<BadgeProps, 'color' | 'children'>;

/**
 * Balans holati nishoni — Moliya jadvali, o'quvchi va ota-ona kartochkalari
 * uchun BITTA ko'rinish (rang/yorliq manbai `lib/balance.ts`).
 *
 * `forwardRef` SHART: Tooltip ichida ishlatiladi, ref uzatilmasa Mantine
 * pozitsiyani hisoblay olmaydi (va React ogohlantirish yozadi).
 */
export const BalanceStatusBadge = forwardRef<HTMLDivElement, Props>(function BalanceStatusBadge(
  { status, ...rest },
  ref
) {
  const { t } = useTranslation();
  return (
    <Badge ref={ref} color={BALANCE_STATUS_COLOR[status]} variant="light" radius="sm" {...rest}>
      {t(balanceStatusKey(status))}
    </Badge>
  );
});
